import { Paper, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../helpers/numbers'
import { ExchangeRateData } from '../../types/exchangeRate'
import useStyles from './styles/ExchangeRateAmountRow.styles'

interface ExchangeRateAmountRowProp {
  data: ExchangeRateData
  weekendIndexes: number[]
  hideZeroes: boolean
}

export default function ExchangeRateAmountRow({
  data,
  weekendIndexes,
  hideZeroes
}: ExchangeRateAmountRowProp) {
  const classes = useStyles()

  return (
    <Paper className={classes.paper} elevation={5}>
      <div className={classes.root}>
        <div className={classes.mainName}>{data.currency}</div>
        {data.dataForEachDate.map((item, index) => (
          <div
            className={[
              classes.dayContainer,
              weekendIndexes.includes(index % 7)
                ? classes.weekendDayContainer
                : ''
            ].join(' ')}
            key={index}>
            <Typography className={classes.valueText}>
              {hideZeroes
                ? addCommaToPrice(
                    parseFloat(item.exchangeRate.toString().slice(0, -4))
                  )
                : addCommaToPrice(item.exchangeRate)}
            </Typography>
          </div>
        ))}
      </div>
    </Paper>
  )
}
